"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCIMErrorSchema = void 0;
var zod_1 = require("zod");
exports.SCIMErrorSchema = zod_1.z.object({
    status: zod_1.z.number(),
    schemas: zod_1.z.tuple([zod_1.z.literal('urn:ietf:params:scim:api:messages:2.0:Error')]),
    detail: zod_1.z.string(),
});
//# sourceMappingURL=Error.js.map